import {
    TableField,
    PanelColumn,
    PanelRow
} from '@assets/component/Panel/PanelTable/PanelTable';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { useStore, useStoreUI } from '@assets/model/Store';
import * as style from '../PanelElements.module.less';

import classNames from 'classnames';
import hand_edit_icon from './hand-edit-icon.svg';
import { DealScore } from '@assets/component/DealDetails/DealScore/DealScore';
import { Button } from 'react-bootstrap';
import { Center } from '@assets/component/Center/Center';
import assert from 'assert';

let removeClassTimeout: ReturnType<typeof setTimeout> | null = null;

export class RowValue {
    static sources(row: PanelRow, col: PanelColumn, data: any) {
        //Pencil edit icon
        const pencilEditIcon = (
            <img
                key="hand_icon"
                src={hand_edit_icon}
                alt="edit"
                className={style.source_page_entry + ' ' + style.editHandIcon}
                onClick={() => {
                    function removeRule() {
                        const stylesheet = document.styleSheets[0];
                        for (let i = 0; i < stylesheet.cssRules.length; i++) {
                            if (
                                (stylesheet.cssRules[i] as any).selectorText ===
                                '.modified_js_tweaked'
                            ) {
                                stylesheet.deleteRule(i);
                                break; // Stop after deleting
                            }
                        }
                    }

                    removeRule();
                    setTimeout(() => {
                        const stylesheet = document.styleSheets[0];
                        stylesheet.insertRule(
                            '.modified_js_tweaked {     animation: colorEditedFieldsAnimation 1s 1; animation-timing-function: ease-in-out; }',
                            stylesheet.cssRules.length
                        );
                    }, 10);

                    if (removeClassTimeout) {
                        clearTimeout(removeClassTimeout);
                    }
                    removeClassTimeout = setTimeout(() => {
                        removeRule();
                    }, 10000);
                }}
            />
        );

        if (row.dontShowSources) {
            data = [];
        }

        const items = [];
        if (!Array.isArray(data)) {
            data = [];
        }

        // Pencil icon removed - using underline instead for edited values

        const storeUI = useStoreUI();
        const isSourceEdited = (() => {
            if (row.editable && storeUI.showEditedUnderlines) {
            var q = useStore().query;
                return q.isValueEditedAtAll(row.field.source) || 
                       q.isValueEditedAtAll(row.field.source + '_page_source');
            }
            return false;
        })();

        data.map((page: number, index: number) => {
            const sourceClasses = classNames(style.source_page_entry, {
                [style.edited]: isSourceEdited
            });
            
            items.push(
                <div
                    key={page}
                    className={sourceClasses}
                    onClick={() => {
                        const uiStore = useStoreUI();
                        uiStore.requestPdfImagePage(page);
                    }}
                >
                    <Center>{page}</Center>
                </div>
            );
        });

        var isModified = false;
        if (row.editable) {
            var q = useStore().query;
            if (q.isValueEditedAtAll(row.field.source + '_page_source')) {
                isModified = true;
            }
        }
        const containerClasses = classNames({
            [style.editable]: row.editable,
            [style.modified_data]: isModified,
            ['modified_js_tweaked']: isModified
        });

        return (
            <Flex
                fillCell={true}
                justify="start"
                alignItems="center"
                className={containerClasses}
                style={{ minWidth: 100 }}
                wrap="wrap"
            >
                {items}
            </Flex>
        );
    }

    static button(
        display: string,
        onClick: (data: any) => void,
        data: any = null,
        isEnabled = true
    ) {
        const cls = classNames({ 'fade-in': isEnabled });
        return (
            <Button
                variant="light"
                onClick={() => onClick(data)}
                style={{ width: '70px', opacity: 0 }}
                className={cls}
                disabled={!isEnabled}
            >
                {display}
            </Button>
        );
    }

    static percent(row: PanelRow, col: PanelColumn, data: any) {
        const storeUI = useStoreUI();
        var isModified = false;
        if (row.editable && storeUI.showEditedUnderlines) {
            var q = useStore().query;
            if (q.isValueEditedByRowCol(row, col)) {
                isModified = true;
            }
        }

        const containerClasses = classNames({
            [style.editable]: row.editable,
            [style.modified_data]: isModified,
            ['modified_js_tweaked']: isModified
        });

        const valueClasses = classNames(style.rowValue, {
            [style.editable]: row.editable,
            [style.modified_data]: isModified,
            [style.edited]: isModified,
            ['modified_js_tweaked']: isModified
        });

        return (
            <Flex
                fillCell={true}
                justify="center"
                alignItems="center"
                className={containerClasses}
            >
                <div className={valueClasses}>
                    <i>{data.toString()}</i>
                </div>
            </Flex>
        );
    }
    static score(row: PanelRow, col: PanelColumn, data: any) {
        return (
            <Flex fillCell={true} alignItems="center" justify={'center'}>
                <DealScore score={data} />
            </Flex>
        );
    }

    static dollar(row: PanelRow, col: PanelColumn, data: any) {
        return RowValue.value(row, col, data /* , style.dollar */);
    }

    static value(
        row: PanelRow,
        col: PanelColumn,
        data: any,
        className?: string
    ) {
        const storeUI = useStoreUI();
        var isModified = false;
        if (row.editable && storeUI.showEditedUnderlines) {
            var q = useStore().query;
            if (q.isValueEditedByRowCol(row, col)) {
                isModified = true;
            }
        }

        const containerClasses = classNames({
            [style.editable]: row.editable,
            [style.modified_data]: isModified,
            ['modified_js_tweaked']: isModified,
            [className || '']: className !== undefined
        });
        const isEdited = (() => {
            if (row.editable && storeUI.showEditedUnderlines) {
                var q = useStore().query;
                return q.isValueEditedByRowCol(row, col);
            }
            return false;
        })();

        const valueClasses = classNames(style.rowValue, {
            [style.editable]: row.editable,
            [style.edited]: isEdited
        });

        assert(
            data,
            `data is not null or undefined: ${row.field.source} ${col.column.source}`
        );
        return (
            <Flex
                fillCell={true}
                alignItems="center"
                className={containerClasses}
            >
                <div className={valueClasses}>{data.toString()}</div>
            </Flex>
        );
    }

    static custom(
        render: (row: PanelRow, col: PanelColumn, data: any) => JSX.Element
    ) {
        const valueClasses = classNames(style.rowValue);
        return (row: PanelRow, col: PanelColumn, data: any) => {
            return (
                <Flex
                    fillCell={true}
                    alignItems="center"
                    className={valueClasses}
                >
                    {render(row, col, data)}
                </Flex>
            );
        };
    }

    static icon(row: PanelRow, col: PanelColumn, data: any) {
        return <div> PDF </div>;
    }
    static booleanCentered(
        row: PanelRow,
        col: PanelColumn,
        data: any,
        centerIcon = false
    ) {
        return RowValue.boolean(row, col, data, true);
    }

    static boolean(
        row: PanelRow,
        col: PanelColumn,
        data: any,
        centerIcon = false
    ) {
        const yes = <i className="bi bi-check"></i>;
        const no = <i className="bi bi-x"></i>;
        const unsure = <i className="bi bi-question"></i>;
        const icon =
            data === true || data === 1 ? yes : data === false ? no : unsure;
        return (
            <Flex
                fillCell={true}
                alignItems="center"
                justify={centerIcon ? 'center' : 'start'}
            >
                <div className={style.rowValueBoolean}>{icon}</div>
            </Flex>
        );
    }
}
